import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BaseDetails from 'containers/Base/BaseDetails.js';
import { openDetails, toggleModal, closeDetails } from 'reducers/ui';
import PropTypes from 'prop-types';

import {
  messageSelectors,
  messagesNameSpace,
  messageActions,
} from 'containers/Pages/Messages/';
import MessageResponse from './response';
import { getUserId } from 'reducers/users';
import { PAGE_URLS } from 'utils/constants';

const MessageDetails = ({
  id,
  cancel,
  setReplyMsg,
  setFwdMsg,
  setEditMode,
}) => {
  //------------------------------Selectors---------------------------------
  const details = useSelector(state =>
    messageSelectors.getMessageDetailsTransformed(state),
  );
  const loading = useSelector(state => state.ui.loading);
  const rawDetails = useSelector(state =>
    messageSelectors.getMessageDetailsRaw(state),
  );
  const currentUser = useSelector(state => getUserId(state));
  const showReply = () => {
    if (rawDetails) {
      if (rawDetails.senderId === null || rawDetails.senderId === '') {
        // it is a system message
        return false;
      } else if (rawDetails.recipientId === currentUser) {
        return true;
      }
    }
    return false;
  };
  //const showReply = useSelector(state => messageSelectors.replyEnabled(state));
  //-----------------------Actions------------------------------------------
  const dispatch = useDispatch();
  const dispatchFetchMessageDetails = useCallback(
    id => dispatch(messageActions.fetchGridRowDetails({ id })),
    [dispatch],
  );
  const dispatchToggleModal = useCallback(
    () => dispatch(toggleModal(messagesNameSpace)),
    [dispatch],
  );
  const dispatchOpenDetails = useCallback(url => dispatch(openDetails(url)), [
    dispatch,
  ]);
  const dispatchCloseDetails = useCallback(url => dispatch(closeDetails(url)), [
    dispatch,
  ]);
  const onEdit = () => {
    setEditMode(true);
    dispatchToggleModal(messagesNameSpace);
  };
  const toggleReply = () => {
    setReplyMsg(true);
    setFwdMsg(false);
  };
  const toggleFwd = () => {
    setReplyMsg(false);
    setFwdMsg(true);
  };
  const operationComponent = () => {
    return (
      <MessageResponse
        toggleModal={onEdit}
        toggleReply={toggleReply}
        toggleFwd={toggleFwd}
        showOrHideReply={showReply()}
      />
    );
  };

  useEffect(() => {
    if (id) {
      dispatchFetchMessageDetails(id);
      dispatchOpenDetails(PAGE_URLS.MESSAGES.link);
    }
  }, [id, dispatchFetchMessageDetails, dispatchOpenDetails]);

  const onCancel = () => {
    cancel();
    dispatchCloseDetails(PAGE_URLS.MESSAGES.link);
  };

  return (
    <BaseDetails
      header="Message Details"
      editable={false}
      details={details}
      cancel={onCancel}
      loading={loading}
      operationComponent={operationComponent()}
    />
  );
};
MessageDetails.propTypes = {
  cancel: PropTypes.func.isRequired,
  editable: PropTypes.bool,
  id: PropTypes.string,
  loading: PropTypes.bool,
  setFwdMsg: PropTypes.func,
  setEditMode: PropTypes.func,
  setReplyMsg: PropTypes.func,
};

export default MessageDetails;
